/*
    This snippet handles auto-selecting the first available size (option 2) when changing materials/formats (option 1).
    Without this, when changing material, the size will stay on the first listed size available
    - whether or not that size is available in that material.

    08/13/2025 - MP
*/

(function () {
  const variantJsonElement = document.querySelector('[data-variant-json]');
  if (!variantJsonElement) return;
  const variants = JSON.parse(variantJsonElement.textContent);

  const option1Select = document.querySelector('select[data-index="option1"]');
  if (!option1Select) return;

  const option2Select = document.querySelector('select[data-index="option2"]');
  if (!option2Select) return;

  option1Select.addEventListener('change', function() {
    const selectedMaterial = option1Select.value;

    const possibleSizes = Array.from(option2Select.options).map(opt => opt.value);

    const availableSizes = possibleSizes.filter(size => 
      variants.some(v => v.option1 === selectedMaterial && v.option2 === size && v.available)
    );

    if (availableSizes.length === 0) return;

    const currentSize = option2Select.value;

    if (!availableSizes.includes(currentSize)) {
      const firstSize = availableSizes[0];
      option2Select.value = firstSize;
      option2Select.dispatchEvent(new Event('change', { bubbles: true }));

      const option2Wrapper = document.querySelector('[data-product-option="option2"]');
      if (option2Wrapper) {
        const buttons = option2Wrapper.querySelectorAll('button[data-button]');
        buttons.forEach(btn => {
          btn.classList.remove('selected');
          if (btn.dataset.optionValue === firstSize) {
            btn.classList.add('selected');
          }
        });
      }
    }
  });
})();